import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { invoiceAPI } from 'redux/invoiceAPI';
import { FetchingState } from '@payer-admin-ui/components-v2/src/types/state';
import { CentsAmount } from '@payer-admin-ui/api/src/external/java/CentsAmount';
import { LocalDate } from '@payer-admin-ui/api/src/external/java/LocalDate';
import { AddManualInvoicePaymentResponse } from '@payer-admin-ui/api/src/invoices/responses/AddManualInvoicePaymentResponse';
import i18n from 'i18next';
import { fetchInvoice } from '../invoicesGlobalState';
import { showSnackbar } from '../../../../redux/snackbar';

export const manualPayment = createAsyncThunk<
  AddManualInvoicePaymentResponse,
  { invoiceNumber: number; amount: CentsAmount; externalReference: string; bookingDate?: LocalDate }
>(
  'invoices/actions/ManualPaymentModal/manualPayment',
  async ({ invoiceNumber, amount, externalReference, bookingDate }, { dispatch }) => {
    const response = await invoiceAPI.actions.manualPayment({
      invoiceNumber,
      amount,
      externalReference,
      bookingDate,
    });
    void dispatch(fetchInvoice({ invoiceNumber: response.invoice.invoiceNumber }));
    dispatch(
      showSnackbar(
        i18n.t('invoices.actions.manualPayment.success', { invoiceNumber: response.invoice.invoiceNumber }),
        {
          severity: 'success',
        },
      ),
    );
    return response;
  },
);

const initialState: FetchingState = {
  isFetching: false,
  success: undefined,
  error: null,
};

const manualPaymentModalSlice = createSlice({
  name: 'invoices/actions/ManualPaymentModal',
  initialState,
  reducers: {
    reset: _state => initialState,
  },
  extraReducers: builder => {
    builder.addCase(manualPayment.pending, () => ({ isFetching: true, success: undefined, error: null }));
    builder.addCase(manualPayment.fulfilled, () => ({
      isFetching: false,
      success: true,
      error: null,
    }));
    builder.addCase(manualPayment.rejected, (_, { error }) => ({
      isFetching: false,
      success: false,
      error,
    }));
  },
});

export const {
  actions: { reset },
  reducer: manualPaymentModalReducer,
} = manualPaymentModalSlice;
